import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=1dd40048&"
import script from "./AdminTemplate.vue?vue&type=script&lang=ts&"
export * from "./AdminTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports